var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, $, _) {
  "use strict";

  M = M || {};

  /**
   * Does the current device support touch events?
   *
   * @return {Boolean}
   */
  M.isTouch = function() {
    return (('ontouchstart' in window) ||
      window.DocumentTouch && document instanceof DocumentTouch);
  };

  // TODO: Replace this code when Modernizr is in place.
  /**
   * Given a string, this function will search the user agent for
   * the string until it finds it, then record the next numbers until
   * it reaches a dot, space, or end of line. It will try to parse
   * that number and return it as browser version number.
   * ex. getBrowserVersion('Chrome/') on Mozilla ... Chrome/26.0.4 will return
   * 26.
   * @param  {string} prefix string before the version number
   * @return {int} version number
   */
  M.getBrowserVersionInt = function(prefix) {
    var version = 0;
    if(prefix == "iOS") {
      if(/iPhone|iPod|iPad/.test(navigator.platform)) {
        var matches = navigator.appVersion.match(/OS (\d+)(_(\d+))*/);
        if (matches) {
          return parseInt(matches[1], 10);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
    var userAgentString = navigator.userAgent;
    if(userAgentString.indexOf(prefix) < 0) {
      return 0;
    }
    var re = new RegExp(prefix + '[^0123456789]*(\\d+)');
    var matches = userAgentString.match(re);
    if (matches) {
      version = parseInt(matches[1], 10)
    }
    return version;
  };

  // returns a string
  M.getBrowserVersion = function(prefix) {
    if(prefix == "iOS") {
      if(/iPhone|iPod|iPad/.test(navigator.platform)) {
        return (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)[1];
      } else {
        return 'not found';
      }
    }
    var userAgentString = navigator.userAgent;
    if(userAgentString.indexOf(prefix) < 0) {
      return 'not found';
    }
    var start = userAgentString.indexOf(prefix) + prefix.length;
    var nextSpaceIdx = userAgentString.indexOf(' ', start);
    var nextDotIdx = userAgentString.indexOf('.', start);
    var end = userAgentString.length;
    if (nextSpaceIdx != -1) {
      end = nextSpaceIdx;
    }
    return userAgentString.substr(start, end-start);
  };

  /**
   * Due to the deprecation of $.browser in jquery 1.9+,
   * this function was written to maintain a similar behaviour
   * required by many parts of the site. The user agent is utilized
   * to determine what browser the user is using. This is a workaround
   * for $.browser and should be replaced if a better alternative is available
   * Based on one of the answers from: http://stackoverflow.com/questions/14365725/
   * @return {dict} mapping of browsers to booleans
   */
  M.getBrowserType = function() {
    var browserList = {
      chrome: false,
      mozilla: false,
      opera: false,
      msie: false,
      safari: false,
      iOS: false,
      webkit: false
    }
    browserList.chrome = (navigator.userAgent.indexOf("Chrome") > -1) ? true : false;
    browserList.mozilla = (navigator.userAgent.indexOf("Mozilla") > -1) ? true : false;
    browserList.opera = (navigator.userAgent.indexOf("Opera") > -1) ? true : false;
    browserList.msie = (navigator.userAgent.indexOf("MSIE") > -1) ? true : false;
    browserList.safari = (navigator.userAgent.indexOf("Safari") > -1) ? true : false;
    browserList.iOS = (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) ? true : false;
    browserList.webkit = (/WebKit/.test(navigator.userAgent)) ? true : false;

    return browserList;
  };

  /**
   * Returns whether or not the current browser satisfies a dictionary
   * of requirements. If no entry is provided for the current browser,
   * then this argument will return false. Use 0 to signify satisfies
   * any version.
   * @param  {dict} requirements mapping of browsers to versions
   * @return {boolean} whether or not requirements are satisfied
   */
  M.satisfiesBrowserRequirements = function(requirements) {
    if (navigator.userAgent.indexOf('Chrome/') > -1) {
      if (requirements.chrome !== undefined &&
        M.getBrowserVersionInt('Chrome/') >= requirements.chrome) {
        return true;
      }
    } else if (navigator.userAgent.indexOf('Firefox/') > -1) {
      if (requirements.firefox !== undefined &&
        M.getBrowserVersionInt('Firefox/') >= requirements.firefox) {
        return true;
      }
    } else if (navigator.userAgent.indexOf('Safari/') > -1) {
      if (requirements.safari !== undefined &&
        M.getBrowserVersionInt('Version/') >= requirements.safari) {
        return true;
      }
    } else if (navigator.userAgent.indexOf('MSIE ') > -1) {
      if (requirements.ie !== undefined &&
        M.getBrowserVersionInt('MSIE ') >= requirements.ie) {
        return true;
      }
    }
    return false;
  };

  return {
  };

});
